import { HTTP } from '@/api/http-common'
import { HttpFunctions } from '@/api/http-functions'

export default {
  getOrderCustomForm (callback) {
    HTTP.get('orders/form').then(response => {
      if (response.status === 200) {
        callback(response)
      } else if (response.status === 403) {
        console.log('Error: pdo error missing')
      } else if (response.status === 401) {
        HttpFunctions.response401()
      }
    }).catch(e => {
      console.log(e)
    })
  },
  addOrderCustomFormField (callback, param) {
    if (param !== undefined) {
      HTTP.post('orders/form', param).then(response => {
        if (response.status === 201) {
          callback(response)
        } else if (response.status === 403) {
          console.log('Error: pdo error missing')
        } else if (response.status === 401) {
          HttpFunctions.response401()
        }
      }).catch(e => {
        if (e.response.status === 400) {
          callback(e.response)
        }
        console.log(e)
      })
    }
  },
  setOrderCustomFormStatus (callback, param) {
    if (param !== undefined) {
      HTTP.put('orders/form/status', param).then(response => {
        if (response.status === 201) {
          callback(response)
        } else if (response.status === 403) {
          console.log('Error: pdo error missing')
        } else if (response.status === 401) {
          HttpFunctions.response401()
        }
      }).catch(e => {
        console.log(e)
      })
    }
  },
  setOrderCustomFormSort (callback, param) {
    if (param !== undefined) {
      HTTP.put('orders/form/sort_field', param).then(response => {
        if (response.status === 200) {
          callback(response)
        } else if (response.status === 403) {
          console.log('Error: pdo error missing')
        } else if (response.status === 401) {
          HttpFunctions.response401()
        }
      }).catch(e => {
        console.log(e)
      })
    }
  },
  deleteOrderCustomFormField (callback, param) {
    if (param !== undefined) {
      HTTP.delete('/orders/form/delete_field', {data: {'form_detail_id': param}}).then(response => {
        if (response.status === 200) {
          callback(response)
        } else if (response.status === 403) {
          console.log('Error: pdo error missing')
        } else if (response.status === 401) {
          HttpFunctions.response401()
        }
      }).catch(e => {
        console.log(e)
      })
    }
  },
  setOrderCustomForm (callback, param) {
    if (param !== undefined) {
      HTTP.put('orders/form', param).then(response => {
        if (response.status === 201) {
          callback(response)
        } else if (response.status === 403) {
          console.log('Error: pdo error missing')
        } else if (response.status === 401) {
          HttpFunctions.response401()
        }
      }).catch(e => {
        if (e.response.status === 400) {
          callback(e.response)
        }
        console.log(e)
      })
    }
  },
  importCsvOrderCustomFormOption (callback, param) {
    if (param !== undefined) {
      HTTP.post('/orders/form/import_csv', param, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(response => {
        if (response.status === 201) {
          callback(response)
        } else if (response.status === 403) {
          console.log('Error: pdo error missing')
        } else if (response.status === 401) {
          HttpFunctions.response401()
        }
      }).catch(e => {
        console.log(e)
      })
    }
  },
  getOptionOrderCustomFormField (callback, param) {
    HTTP.get('orders/form/options?' + param).then(response => {
      if (response.status === 200) {
        callback(response)
      } else if (response.status === 403) {
        console.log('Error: pdo error missing')
      } else if (response.status === 401) {
        HttpFunctions.response401()
      }
    }).catch(e => {
      console.log(e)
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/order_custom_form/index.js